import {
  buildScheduleHref,
  type ScheduleFrom,
} from "./publicationFlow/route/scheduleUrl";
import type { InitialCalendarPlacement } from "./publicationFlow/calendarPlacement";
// Each scheduling entry names its folder or standalone owner and its mode.

export const scheduleHrefForVideos = ({
  folderId,
  videoIds,
  focusVideoId,
  from,
  returnDate,
  initialPlacement,
}: {
  folderId: string;
  videoIds: readonly string[];
  focusVideoId?: string | null;
  from: ScheduleFrom;
  returnDate?: string | null;
  initialPlacement?: InitialCalendarPlacement;
}) =>
  buildScheduleHref({
    project: folderId,
    mode: "create",
    videos: videoIds,
    video: focusVideoId ?? videoIds[0] ?? null,
    from,
    returnDate,
    initialPlacement,
  });

export const scheduleHrefForShort = ({
  video,
  from,
  returnDate,
  initialPlacement,
}: {
  video: { id: string; folderId?: string | null };
  from: ScheduleFrom;
  returnDate?: string | null;
  initialPlacement?: InitialCalendarPlacement;
}) =>
  buildScheduleHref({
    project: video.folderId,
    standalone: video.folderId ? undefined : video.id,
    mode: "create", videos: [video.id], video: video.id, from, returnDate, initialPlacement,
  });

export const scheduleHrefForPublication = ({
  publication,
  folderId,
  returnDate,
}: {
  publication: { id: string; projectId: string };
  folderId?: string | null;
  returnDate?: string | null;
}) =>
  buildScheduleHref({
    project: folderId,
    standalone: folderId ? undefined : publication.projectId,
    mode: "edit",
    video: publication.projectId,
    post: publication.id,
    from: "calendar",
    returnDate,
  });
